import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ReposeGroupHelperService {
    loadingEmitter = new EventEmitter<boolean>();
    pageUpdateEmitter = new EventEmitter<boolean>();

    showLoading() {
        this.loadingEmitter.emit(true);
    }

    hideLoading() {
        this.loadingEmitter.emit(false);
    }

    groupUpdated() {
        this.pageUpdateEmitter.emit(true);
    }
}
